import React from 'react';
import { Zap, Fuel } from 'lucide-react';

export default function VehicleCard({
    type,
    data,
    selectedMake,
    selectedModel,
    selectedClass = 'All',
    classOptions = [],
    onClassChange = null,
    onMakeChange,
    onModelChange,
    selectedDisplayMake,
    selectedDisplayModel,
    disableMakeModel = false,
    showSelectedSummary = false,
    forceDefaultSelectors = false,
}) {
    const isEV = type === 'ev';
    const models = data[selectedMake]?.models || [];
    const displayMake = selectedDisplayMake || selectedMake;
    const displayModel = selectedDisplayModel || selectedModel;

    return (
        <div className={`bg-white rounded-2xl border ${isEV ? 'border-blue-100' : 'border-gray-100'} shadow-sm overflow-hidden`}>
            {/* Card header */}
            <div className={`px-6 py-4 flex items-center gap-3 ${isEV ? 'bg-blue-50 border-b border-blue-100' : 'bg-gray-50 border-b border-gray-100'}`}>
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${isEV ? 'bg-blue-600' : 'bg-slate-700'}`}>
                    {isEV ? <Zap className="w-4 h-4 text-white" strokeWidth={2} /> : <Fuel className="w-4 h-4 text-white" strokeWidth={2} />}
                </div>
                <div>
                    <div className="text-xs font-medium text-gray-400 uppercase tracking-wider">{isEV ? 'Electric Vehicle' : 'Diesel / Gas Vehicle'}</div>
                    {showSelectedSummary && (
                        <div className="text-sm font-semibold text-gray-900">{displayMake} {displayModel}</div>
                    )}
                </div>
            </div>

            {/* Selectors */}
            <div className="px-6 py-5 space-y-3">
                {classOptions.length > 0 && onClassChange && (
                    <div>
                        <label className="text-xs text-gray-400 font-medium mb-1 block">Vehicle Class</label>
                        <select
                            value={selectedClass}
                            onChange={e => onClassChange(e.target.value)}
                            className="w-full text-sm border border-gray-200 rounded-lg px-3 py-2 bg-white text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400 transition-colors"
                        >
                            {classOptions.map((option) => (
                                <option key={option.value} value={option.value}>{option.label}</option>
                            ))}
                        </select>
                    </div>
                )}
                <div>
                    <label className="text-xs text-gray-400 font-medium mb-1 block">Make</label>
                    <select
                        value={forceDefaultSelectors ? 'Default' : selectedMake}
                        onChange={e => onMakeChange(e.target.value)}
                        disabled={disableMakeModel || forceDefaultSelectors}
                        className="w-full text-sm border border-gray-200 rounded-lg px-3 py-2 bg-white text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400 transition-colors"
                    >
                        {forceDefaultSelectors
                            ? <option value="Default">Default</option>
                            : Object.keys(data).map(make => (
                                <option key={make} value={make}>{make}</option>
                            ))}
                    </select>
                </div>
                <div>
                    <label className="text-xs text-gray-400 font-medium mb-1 block">Model</label>
                    <select
                        value={forceDefaultSelectors ? 'Default' : selectedModel}
                        onChange={e => onModelChange(e.target.value)}
                        disabled={disableMakeModel || forceDefaultSelectors}
                        className="w-full text-sm border border-gray-200 rounded-lg px-3 py-2 bg-white text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400 transition-colors"
                    >
                        {forceDefaultSelectors
                            ? <option value="Default">Default</option>
                            : models.map(model => (
                                <option key={model} value={model}>{model}</option>
                            ))}
                    </select>
                </div>
            </div>
        </div>
    );
}
